import Header from './Header'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selectedRegionId,
    regionsData: state.REGIONS.regionsData
  }
}

export default withRouter(connect(mapStateToProps)(Header))



// WEBPACK FOOTER //
// ./src/components/Header/index.js